import { Box, Modal, Typography, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { CustomGridToolbar } from "../../utils/dataGridCustom";
import { tokens } from "../../theme";
import { useEffect, useState } from "react";
import Loader from "../global/Loader";
import { pageSizeOptions, pageSize, page } from "../../utils/paginationConfig";
import { getAllPerformance } from "../../services/center-performance-services/getAllPerformanceService";
import { toast } from "react-toastify";
import { getSelectedCenterPCDetails, getSelectedCenterPerformance
} from "../../services/center-performance-services/getSelectedCenter";
import { useDispatch } from "react-redux";
import { SetCurrentPageTopic } from "../../store/action/headerChange";
import { saveAs } from "file-saver";

const CenterPerformance = () => {
  const dispatch = useDispatch();
  dispatch(SetCurrentPageTopic("PERFORMANCE DETAILS"));

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    overflowY: "scroll",
    width: "1000px",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    textAlign: "center",
  };

  const [isLoading, setIsLoading] = useState(true);
  const [isLoading2, setIsLoading2] = useState(true);

  const [paginationModel, setPaginationModel] = useState({
    page: page,
    pageSize: pageSize,
  });
  const [rowCount, setRowCount] = useState(0);
  const [paginationModel2, setPaginationModel2] = useState({
    page: page,
    pageSize: pageSize,
  });
  const [rowCount2, setRowCount2] = useState(0);
  const [data, setData] = useState(true);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [date, setDate] = useState("");
  const [openedTime, setOpenedTime] = useState("");
  const [closedTime, setClosedTime] = useState("");
  const [duration, setDuration] = useState("");
  const [todayPCs, setTodayPCs] = useState("");
  const [allPCs, setAllPCs] = useState("");
  const [studentCount, setStudentCount] = useState("");
  const [pcPercentage, setPcPercentage] = useState("");
  const [centerName, setCenterName] = useState("");
  const [centerCode, setCenterCode] = useState("");
  const [pcData, setPcData] = useState("");

  const headerData = ["Date", "Center Name", "Opened Time", "Closed Time", "Duration"];
  const headerData2 = ["PC Id", "Worked Time", "Performance", "Student Count"];

  useEffect(() => {
    const fetchData = async () => {
      await handleTableData(paginationModel.page, paginationModel.pageSize);
    };
    fetchData();
  }, []);

  const handleTableData = async (
    page = paginationModel.page,
    limit = paginationModel.pageSize
  ) => {
    setIsLoading(true);
    setPaginationModel({ page: page, pageSize: limit });

    try {
      const obj = { page, limit };

      const response = await getAllPerformance(obj);
      setData(response.data.data);
      setRowCount(response.data.totalCount ?? 0);
    } catch (error) {
      console.log(error);
      toast.error("Please refresh");
    }
    setIsLoading(false);
  };

  const handleExportCSV = async () => {
    try {
      const response = await getAllPerformance({ page: 0, limit: rowCount });

      const data = response.data.data;
      const csvRows = data.map((row) =>
        [
          row.openDate,
          row.centerName,
          row.startTime,
          row.endTime,
          row.duration,
        ].join(",")
      );

      const csvContent = [headerData.join(","), ...csvRows].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, `performance_details.csv`);
    } catch (error) {
      console.error("CSV Export Failed:", error);
      toast.error("Failed to export CSV.");
    }
  };

  const handlePaginationModelChange = (newModel) => {
    const resetPage = newModel.pageSize !== paginationModel.pageSize;
    const updatedModel = {
      ...newModel,
      page: resetPage ? 0 : newModel.page,
    };

    setPaginationModel(updatedModel);
    handleTableData(updatedModel.page, updatedModel.pageSize);
  };

  const handleCellClick = async (params) => {
    if (params.field === "centerName") {
      console.log("dj", params.row.centerCode);
      setDate(params.row.openDate);
      setOpenedTime(params.row.startTime);
      setClosedTime(params.row.endTime);
      setDuration(params.row.duration);
      setCenterCode(params.row.centerCode);
      setCenterName(params.row.centerName);
      handleOpen();
      try {
        const response = await getSelectedCenterPerformance(
          params.row.centerCode,
          params.row.openDate,
          params.row.status
        );

        setAllPCs(response.data.allPcCount);
        setTodayPCs(response.data.WorkedPCs);
        setStudentCount(response.data.studentCount);
        setPcPercentage(response.data.pcsPerformance);

        await handlePcPerformancdTableData(page, pageSize, {
          centerCode: params.row.centerCode,
          openDate: params.row.openDate,
        });
      } catch (error) {}
    }
  };

  const handlePcPerformancdTableData = async (
    page = paginationModel.page,
    limit = paginationModel.pageSize,
    params
  ) => {
    setIsLoading2(true);
    setPaginationModel2({ page: page, pageSize: limit });

    try {
      const obj = {
        page,
        limit,
        centerCode: params.centerCode,
        openDate: params.openDate,
      };

      const response = await getSelectedCenterPCDetails(obj);
      setPcData(response.data.data);
      setRowCount2(response.data.totalCount ?? 0);
    } catch (error) {
      console.log(error);
      toast.error("Please refresh");
    }

    setIsLoading2(false);
  };

  const handleExportCSV2 = async () => {
    try {
      const response = await getSelectedCenterPCDetails({
        page: 0,
        limit: rowCount2,
        centerCode,
        openDate: date,
      });

      const data = response.data.data;
      const csvRows = data.map((row) =>
        [
          row.pcCode,
          row.durationInMin,
          row.pcPerformance,
          row.studentCount,
        ].join(",")
      );

      const csvContent = [headerData2.join(","), ...csvRows].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, `performance_details_${centerName}.csv`);
    } catch (error) {
      console.error("CSV Export Failed:", error);
      toast.error("Failed to export CSV.");
    }
  };

  const handlePaginationModelChange2 = (newModel) => {
    const resetPage = newModel.pageSize !== paginationModel2.pageSize;
    const updatedModel = {
      ...newModel,
      page: resetPage ? 0 : newModel.page,
    };

    setPaginationModel2(updatedModel);
    handlePcPerformancdTableData(updatedModel.page, updatedModel.pageSize, {
      centerCode,
      openDate: date,
    });
  };

  const columns = [
    {
      field: "openDate",
      headerName: headerData[0],
      flex: 2,
      cellClassName: "name-column--cell",
    },
    {
      field: "centerName",
      headerName: headerData[1],
      flex: 6,
      renderCell: (params) => (
        <Box style={{ textTransform: "uppercase", cursor: "pointer" }}>
          {params.value}
        </Box>
      ),
    },
    {
      field: "startTime",
      headerName: headerData[2],
      flex: 2,
      cellClassName: "name-column--cell",
    },
    {
      field: "endTime",
      headerName: headerData[3],
      flex: 2,
      cellClassName: "name-column--cell",
    },
    {
      field: "duration",
      headerName: headerData[4],
      flex: 2,
      cellClassName: "name-column--cell",
    },
  ];

  const inColumns = [
    {
      field: "pcCode",
      headerName: headerData2[0],
      flex: 6,
      renderCell: (params) => (
        <Box style={{ textTransform: "uppercase", cursor: "pointer" }}>
          {params.value}
        </Box>
      ),
    },
    {
      field: "durationInMin",
      headerName: headerData2[1],
      flex: 2,
      cellClassName: "name-column--cell",
    },
    {
      field: "pcPerformance",
      headerName: headerData2[2],
      flex: 2,
      cellClassName: "name-column--cell",
    },
    {
      field: "studentCount",
      headerName: headerData2[3],
      flex: 2,
      cellClassName: "name-column--cell",
    },
  ];
  return (
    <Box m="0 20px">
      {isLoading ? (
        <Loader />
      ) : (
        <Box
          display="grid"
          height="78vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              fontSize: "15px",
            },
            "& .name-column--cell": {
              color: colors.primary[100],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              border: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
              color: `${colors.redAccent[100]} !important`,
            },
          }}
        >
          <DataGrid
            rows={data}
            getRowId={(row) => row.attendanceCode}
            columns={columns}
            paginationMode="server"
            rowCount={rowCount}
            pageSizeOptions={pageSizeOptions}
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationModelChange}
            loading={isLoading}
            components={{ Toolbar: CustomGridToolbar }}
            componentsProps={{
              toolbar: {
                onExport: handleExportCSV,
              },
            }}
            onCellClick={handleCellClick}
          />
        </Box>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box>
            <Typography id="modal-modal-description" variant="h3">
              {centerName}
            </Typography>
          </Box>
          <Box display="flex">
            <Box
              sx={{
                textAlign: "left",
                display: "grid",
                justifyContent: "space-evenly",
              }}
            >
              <Typography variant="h5">Date</Typography>
              <Typography variant="h5">Opened Time</Typography>
              <Typography variant="h5">Closed Time</Typography>
              <Typography variant="h5">Worked Time</Typography>
              <Typography variant="h5">Student Count</Typography>
              <Typography variant="h5">PC Count</Typography>
              <Typography variant="h5">PC Performance</Typography>
            </Box>
            <Box
              sx={{
                textAlign: "right",
                display: "grid",
                justifyContent: "space-evenly",
                width: "50px",
              }}
            >
              <Typography variant="h5">:</Typography>
              <Typography variant="h5">:</Typography>
              <Typography variant="h5">:</Typography>
              <Typography variant="h5">:</Typography>
              <Typography variant="h5">:</Typography>
              <Typography variant="h5">:</Typography>
              <Typography variant="h5">:</Typography>
            </Box>
            <Box
              sx={{
                textAlign: "left",
                display: "grid",
                justifyContent: "space-evenly",
              }}
            >
              <Typography variant="h5">{date}</Typography>
              <Typography variant="h5">{openedTime}</Typography>
              <Typography variant="h5">{closedTime}</Typography>
              <Typography variant="h5">{`${duration} h`}</Typography>
              <Typography variant="h5">{studentCount}</Typography>
              <Typography variant="h5">{`${todayPCs} / ${allPCs}`}</Typography>
              <Typography variant="h5">{`${pcPercentage} %`}</Typography>
            </Box>
          </Box>
          {isLoading2 ? (
            <Loader />
          ) : (
            <Box
              display="grid"
              height="58vh"
              sx={{
                "& .MuiDataGrid-root": {
                  border: "none",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                  fontSize: "15px",
                },
                "& .name-column--cell": {
                  color: colors.primary[100],
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: colors.blueAccent[700],
                  border: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: colors.primary[400],
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                  backgroundColor: colors.blueAccent[700],
                },
                "& .MuiCheckbox-root": {
                  color: `${colors.greenAccent[200]} !important`,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                  color: `${colors.redAccent[100]} !important`,
                },
              }}
            >
              <DataGrid
                rows={pcData}
                getRowId={(row) => row.pcCode}
                columns={inColumns}
                paginationMode="server"
                rowCount={rowCount2}
                pageSizeOptions={pageSizeOptions}
                paginationModel={paginationModel2}
                onPaginationModelChange={handlePaginationModelChange2}
                loading={isLoading}
                components={{ Toolbar: CustomGridToolbar }}
                componentsProps={{
                  toolbar: {
                    onExport: handleExportCSV2,
                  },
                }}
              />
            </Box>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default CenterPerformance;
